export default __webpack_public_path__ + "static/media/dhanush.3417d3f1.jpg";